import React from 'react';
import { A } from 'hookrouter';
import { validURL, validEmail } from '../shared/FormatHelpers';

const DisplayText = ({ value, urlLink }) => {
    if (urlLink && urlLink.length) {
        return (
            <A className='d-block' title={value} href={urlLink}>
                <div>{value}</div>
            </A>
        );
    } else if (validURL(value)) {
        return (
            <a className='text-primary' href={value} target='_blank' without='true' rel='noopener noreferrer'>
                {value}
            </a>
        );
    } else if (validEmail(value)) {
        return (
            <a className='text-primary' href={`mailto:${value}`} target='_blank' without='true' rel='noopener noreferrer'>
                {value}
            </a>
        );
    }
    return <div>{value}</div>;
};

export default DisplayText;
